import React from "react";

const ClientFooter = () => {
  return (
    <footer className="bg-white border-t text-center text-gray-500 py-3 text-sm">
      <p>
        © {new Date().getFullYear()} — Connecting Clients with Quality Products 🤝
      </p>
    </footer>
  );
};

export default ClientFooter;
